/**
* 用户操作记录时间线组件
*/ 
<template>
  <div class="block">
    <el-timeline>
        <el-timeline-item
        v-for="(item, index) in list"
        :key="index"
        :icon="item.icon"
        :type="item.type"
        :color="item.color"
        :size="item.size"
        :timestamp="item.timestamp">
        {{item.content}}
        </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
export default {
  name: 'UserLogsTimeline',
  props: ['list'],
  data() {
    return {
    }
  },
  watch: {
    list: (n,o) => {
      this.list = n
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/UserLogsTimeline.vue